"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.searchOptions = exports.sortByOptions = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/bid/questions");
const _CrudReducer = require("../../modules/files/crud/reducers");
const CrudReducer = _CrudReducer.default('bid-answer-file');
exports.sortByOptions = {
    sortBy: 'name-meta',
    order: 'asc',
    limit: 0,
    offset: 0
};
exports.searchOptions = {
    filtering: 'NONE',
    from: null,
    to: null,
    meta: null,
    metaValue: null,
    moreSearch: false,
    toggleRecents: false,
    toggleShowBookmarks: false,
    toggleHideEmptyFolders: false,
    limitSearchToMetadata: false,
    searchString: '',
    searchFileType: fp.option.none,
    limitSearchToFolder: fp.option.none
};
exports.initialState = {
    listStatus: 'STANDBY',
    list: [],
    answerFileStatus: 'STANDBY',
    answerFile: [],
    addQuestionModal: false,
    addQuestionStatus: 'STANDBY',
    answerQuestionsModal: false,
    answerQuestionsStatus: 'STANDBY',
    answerQuestions: [],
    selected: [],
    excludeStatus: 'STANDBY',
    metaStatus: 'STANDBY',
    createErrors: fp.option.none,
    answerErrors: fp.option.none,
    crud: Object.assign({}, CrudReducer.initialState)
};
const listStatusLens = monocle.Lens.fromProp('listStatus');
const listLens = monocle.Lens.fromProp('list');
const selectedLens = monocle.Lens.fromProp('selected');
const answerFileStatusLens = monocle.Lens.fromProp('answerFileStatus');
const answerFileLens = monocle.Lens.fromProp('answerFile');
const addQuestionsModalLens = monocle.Lens.fromProp('addQuestionModal');
const addQuestionsStatusLens = monocle.Lens.fromProp('addQuestionStatus');
const answerQuestionsModalLens = monocle.Lens.fromProp('answerQuestionsModal');
const answerQuestionsStatusLens = monocle.Lens.fromProp('answerQuestionsStatus');
const answerQuestionsLens = monocle.Lens.fromProp('answerQuestions');
const excludeLens = monocle.Lens.fromProp('excludeStatus');
const metaStatusLens = monocle.Lens.fromProp('metaStatus');
const createErrorsLens = monocle.Lens.fromProp('createErrors');
const answerErrorsLens = monocle.Lens.fromProp('answerErrors');
const crudLens = monocle.Lens.fromProp('crud');
exports.methods = {};
Object.keys(CrudReducer.methods).reduce((prev, curr) => {
    prev[curr] = (state, action) => crudLens.set(CrudReducer.reducer(state.crud, action))(state);
    return prev;
}, exports.methods);
exports.methods[ActionTypes.FETCH_REQUEST] = (state, action) => fp.function.compose(listStatusLens.set('FETCHING'), selectedLens.set([]), excludeLens.set('STANDBY'))(state);
exports.methods[ActionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(listLens.set(action.payload), listStatusLens.set('FETCHED'))(state);
exports.methods[ActionTypes.FETCH_FAILED] = (state, action) => listStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.SELECT] = (state, action) => selectedLens.modify((x) => action.payload.reduce((acc, selected) => {
    if (acc.findIndex((z) => z.id === selected.id) === -1) {
        acc.push(selected);
    }
    return acc;
}, [...x]))(state);
exports.methods[ActionTypes.UNSELECT] = (state, action) => selectedLens.modify((x) => [...x].filter((z) => action.payload.findIndex((y) => y.id === z.id) === -1))(state);
exports.methods[ActionTypes.TOGGLE_ADD_QUESTION] = (state, action) => fp.function.compose(addQuestionsModalLens.modify((x) => action.payload === undefined ? !x : action.payload), addQuestionsStatusLens.set('STANDBY'))(state);
exports.methods[ActionTypes.ADD_QUESTION_REQUEST] = (state, action) => fp.function.compose(createErrorsLens.set(fp.option.none), addQuestionsStatusLens.set('FETCHING'))(state);
exports.methods[ActionTypes.ADD_QUESTION_SUCCESS] = (state, action) => addQuestionsStatusLens.set('FETCHED')(state);
exports.methods[ActionTypes.ADD_QUESTION_FAILED] = (state, action) => addQuestionsStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.ADD_QUESTION_VALIDATION_FAILED] = (state, action) => fp.function.compose(createErrorsLens.set(fp.option.some(action.payload.reduce((rv, x) => {
    ;
    (rv[x.key] = rv[x.key] || []).push(x.value);
    return rv;
}, {}))), addQuestionsStatusLens.set('STANDBY'))(state);
exports.methods[ActionTypes.TOGGLE_ANSWER_QUESTION] = (state, action) => fp.function.compose(answerQuestionsLens.set(action.payload.questions), answerQuestionsModalLens.modify((x) => action.payload.status === undefined ? !x : action.payload.status), answerQuestionsStatusLens.set('STANDBY'))(state);
exports.methods[ActionTypes.ANSWER_QUESTION_REQUEST] = (state, action) => fp.function.compose(answerErrorsLens.set(fp.option.none), answerQuestionsStatusLens.set('FETCHING'))(state);
exports.methods[ActionTypes.ANSWER_QUESTION_SUCCESS] = (state, action) => answerQuestionsStatusLens.set('FETCHED')(state);
exports.methods[ActionTypes.ANSWER_QUESTION_FAILED] = (state, action) => answerQuestionsStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.ANSWER_QUESTION_VALIDATION_FAILED] = (state, action) => fp.function.compose(answerErrorsLens.set(fp.option.some(action.payload.reduce((rv, x) => {
    ;
    (rv[x.key] = rv[x.key] || []).push(x.value);
    return rv;
}, {}))), answerQuestionsStatusLens.set('STANDBY'))(state);
exports.methods[ActionTypes.TOGGLE_EXCLUDE_STATUS_REQUEST] = (state, action) => excludeLens.set('FETCHING')(state);
exports.methods[ActionTypes.TOGGLE_EXCLUDE_STATUS_SUCCESS] = (state, action) => excludeLens.set('FETCHED')(state);
exports.methods[ActionTypes.TOGGLE_EXCLUDE_STATUS_FAILED] = (state, action) => excludeLens.set('FAILED')(state);
// Meta status§
exports.methods[ActionTypes.SAVE_METAS_REQUEST] = (state, action) => metaStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.SAVE_METAS_SUCCESS] = (state, action) => metaStatusLens.set('FETCHED')(state);
exports.methods[ActionTypes.SAVE_METAS_FAILED] = (state, action) => metaStatusLens.set('FAILED')(state);
// LIST
exports.methods[ActionTypes.ListActionTypes.FETCH_REQUEST] = (state, action) => answerFileStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.ListActionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(answerFileLens.set(action.payload.files.reduce((acc, x) => {
    if (x.type !== 'FOLDER') {
        acc.push(x);
    }
    return acc;
}, [])), answerFileStatusLens.set('FETCHED'))(state);
exports.methods[ActionTypes.ListActionTypes.FETCH_FAILURE] = (state, action) => answerFileStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.CLEAR] = (state, action) => (Object.assign({}, exports.initialState));
//# sourceMappingURL=questions.js.map